import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from '../SnackBar';

export const RULE_CATEGORY_PATCH_REQUEST = 'PATCH_RULE_CATEGORY_REQUEST';
export const RULE_CATEGORY_PATCH_FAILURE = 'PATCH_RULE_CATEGORY_FAILURE';
export const RULE_CATEGORY_PATCH_SUCCESS = 'PATCH_RULE_CATEGORY_SUCCESS';

export const patchRuleCategory = (data, id, rule) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.RULE_CATEGORIES.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data, rule));
                dispatch(addSuccessMessage('Rule category successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return { type: RULE_CATEGORY_PATCH_REQUEST }
};

const postFailure = (error) => {
    return { type: RULE_CATEGORY_PATCH_FAILURE, error }
};

const patchSuccess = (ruleCategory, rule) => {
    return { type: RULE_CATEGORY_PATCH_SUCCESS, ruleCategory, rule }
};